import { render, staticRenderFns } from "./EventGroup.vue?vue&type=template&id=c4afb262&scoped=true"
import script from "./EventGroup.vue?vue&type=script&lang=ts"
export * from "./EventGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4afb262",
  null
  
)

export default component.exports